import { API_BASE_URL } from "@kupikupi/brand";
import { useQuery } from "@tanstack/react-query";
import { queryStoredOrderItems } from "../endpoints/order";
import { useBackendCurrency, useBackendLang } from "../lang-context";
import type { StoredOrderListUrlInput } from "../path-adapter";
import type { StoredOrderListResult } from "../types/order";

/**
 * `GET /order/stored/list@2` — paged list of OrderItems that have already
 * arrived in the CN warehouse. Drives the `/warehouse` page (我的仓库).
 *
 * Pass `isParcelable: "Y"` (default) for ready-to-parcel items, `"N"` for
 * the held bucket (returning / expired). Auth required; null token disables.
 */
export function useStoredOrderItems(authToken: string | null, input: StoredOrderListUrlInput = {}) {
  const lang = useBackendLang();
  const currency = useBackendCurrency();
  return useQuery<StoredOrderListResult>({
    queryKey: ["warehouse", "stored", input, lang, currency],
    enabled: !!authToken,
    queryFn: () => {
      if (!authToken) throw new Error("NO_TOKEN");
      return queryStoredOrderItems({ baseUrl: API_BASE_URL }, authToken, input, { lang, currency });
    },
    staleTime: 30_000,
  });
}
